import Backbone from 'backbone';

/* eslint import/prefer-default-export: 0 */
export function postCSV({
  url, data, success, error, complete,
}) {
  Backbone.$.ajax({
    url,
    data,
    type: 'POST',
    contentType: 'text/csv',
  })
    .done(success)
    .fail(error)
    .always(complete);
}



// WEBPACK FOOTER //
// ./utils/xhr.js